import { connect } from 'react-redux';
import { pipe, propOr } from 'ramda';
import { compose, withHandlers } from 'recompose';
import qs from 'qs';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getExtrasData } from '@olxbr/mojo-jojo/selectors/extras';
import { getMetaData } from '@olxbr/mojo-jojo/selectors/meta';
import { getAdData } from '@olxbr/mojo-jojo/selectors/ad';
import { getCurrentContent } from '@olxbr/mojo-jojo/selectors/content';

import { getSource } from '../../libs/browser/browser';
import { sendBuyClick } from '../../services/tracking';
import CheckoutButton from './CheckoutButton';

const getLabel = pipe(
  getCurrentContent,
  propOr('Comprar', 'checkoutButton'),
);

const getAuthenticated = pipe(
  getMetaData,
  propOr(false, 'authenticated'),
);

const mapStateToProps = state => ({
  extrasData: getExtrasData(state),
  posData: getPOSData(state),
  adData: getAdData(state),
  label: getLabel(state),
  authenticated: getAuthenticated(state),
});

const configureHandlers = withHandlers({
  onClick: props => () => {
    const { REACT_APP_OCTOPOS_HOST } = process.env;
    const {
      product, posData, adData, extrasData
    } = props;
    const { type: productCode, discountId } = product;
    const {
      name: pointOfSale, parentName: posParentName, referral, coupon, funnelId,
    } = posData;
    const {
      legacyAdId,
      listId,
      adId,
      categoryId,
      region,
      zipcode,
    } = adData;
    const platform = getSource();
    const { tag_id: tagId, product_name: productName } = propOr({}, 'rtb', extrasData);
    const utms = (document.location.search.match(/(utm_[\w]+=[\w_-]*)/g) || []).join('&');
    const params = {
      adId, productCode, pointOfSale, platform, referral, coupon, rtb_tag_id: tagId, rtb_product_name: productName, funnelId, utms, discountId,
    };
    sendBuyClick({
      adId: legacyAdId,
      listId,
      product: productCode,
      pointOfSale: posParentName,
      referral,
      funnelId,
      categoryId,
      region,
      zipcode,
    });
    if (product.totalPrice === 0) {
      window.open(`${REACT_APP_OCTOPOS_HOST}/api/v1/activate?${qs.stringify(params)}`, '_self');
    } else {
      window.open(`${REACT_APP_OCTOPOS_HOST}/api/v1/buy?${qs.stringify(params)}`, '_self');
    }    
  },
});

export default compose(
  connect(mapStateToProps),
  configureHandlers,
)(CheckoutButton);
